import axios from 'axios'

const provisional_broker_form = {
  namespaced: true,
  state() {
    return {
      data: {
        email: null
      },
      errors: {},
    }
  },
  getters: {
    parameters(state) {
      return Object.assign({}, state.data);
    },
  },
  mutations: {
    setErrors(state, errors) {
      state.errors = {...errors}
    },
    resetData(state) {
      state.data.email = null
      state.errors = {}
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },
  actions: {
    send({getters, commit}) {
      return new Promise((resolve, reject) => {
        axios.post('/api/brokers/provisional', getters.parameters).then(() => {
          commit('setFlashMessage', {value: '送信しました'}, {root: true});
          commit('resetData')
          commit('clearError')
          resolve(true)
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    }
  }
}
export default provisional_broker_form;
